import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "fridgedetails-drumpicker" }
const _hoisted_2 = { class: "fridgedetails-drumpicker-content" }
const _hoisted_3 = { class: "fridgedetails-drumpicker-content-common fridgedetails-drumpicker-content-minutes" }
const _hoisted_4 = {
  class: "fridgedetails-drumpicker-content-common-scroll-content",
  ref: "minutesParentContent"
}
const _hoisted_5 = { class: "fridgedetails-drumpicker-content-common-scroll-content-item-text" }
const _hoisted_6 = { class: "fridgedetails-drumpicker-content-common-name" }
const _hoisted_7 = { class: "fridgedetails-drumpicker-content-common-name-text" }
const _hoisted_8 = {
  key: 0,
  class: "fridgedetails-drumpicker-content-common fridgedetails-drumpicker-content-seconds"
}
const _hoisted_9 = {
  class: "fridgedetails-drumpicker-content-common-scroll-content",
  ref: "secondsParentContent"
}
const _hoisted_10 = { class: "fridgedetails-drumpicker-content-common-scroll-content-item-text" }
const _hoisted_11 = { class: "fridgedetails-drumpicker-content-common-name" }
const _hoisted_12 = { class: "fridgedetails-drumpicker-content-common-name-text" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "fridgedetails-drumpicker-focus" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "fridgedetails-drumpicker-gradation-top" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "fridgedetails-drumpicker-gradation-bottom" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          class: "fridgedetails-drumpicker-content-common-scroll fridgedetails-drumpicker-content-minutes-scroll",
          ref: "minutesScroll",
          onTouchstart: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.minitesTouchStart(...args))),
          onTouchMove: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.minitesTouchMove(...args))),
          onTouchEnd: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.minitesTouchEnd(...args))),
          onScroll: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onMinutesScroll($event)))
        }, [
          _createVNode("div", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.minutesContents, (content) => {
              return (_openBlock(), _createBlock("div", {
                class: "fridgedetails-drumpicker-content-common-scroll-content-item",
                key: content.index
              }, [
                _createVNode("span", _hoisted_5, _toDisplayString(content.displayText), 1)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ], 512)
        ], 544),
        _createVNode("div", _hoisted_6, [
          _createVNode("span", _hoisted_7, _toDisplayString(_ctx.minutesText), 1)
        ])
      ]),
      (_ctx.isValidSeconds)
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _createVNode("div", {
              class: "fridgedetails-drumpicker-content-common-scroll fridgedetails-drumpicker-content-seconds-scroll",
              ref: "secondsScroll",
              onTouchstart: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.secondsTouchStart(...args))),
              onTouchMove: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.secondsTouchMove(...args))),
              onTouchEnd: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.secondsTouchEnd(...args))),
              onScroll: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onSecondsScroll($event)))
            }, [
              _createVNode("div", _hoisted_9, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.secondsContents, (content) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "fridgedetails-drumpicker-content-common-scroll-content-item",
                    key: content.index
                  }, [
                    _createVNode("span", _hoisted_10, _toDisplayString(content.displayText), 1)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512)
            ], 544),
            _createVNode("div", _hoisted_11, [
              _createVNode("span", _hoisted_12, _toDisplayString(_ctx.secondsText), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_13,
    _hoisted_14,
    _hoisted_15
  ]))
}